import { defineComponent as _defineComponent } from 'vue'
import LotAssignmentModal from "@/components/ui/modals/LotAssignmentModal.vue";
  import store from "@/store";
  
  import { useToast } from "vue-toastification";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'LotApproveModal',
  props: {
    lot: {
      type: Object,
      required: true,
    },
    isOpen: {
      type: Boolean,
    },
  },
  emits: ["close", "confirm", "loading"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const toast = useToast();
  const emits = __emit;
  const props = __props;

  function close() {
    emits("close");
  }

  const confirm = () => {
    emits("loading");
    store
      .dispatch("eoi/approveEoi", {
        eoiId: props.lot?.eoiId,
        lotId: props.lot?.lotId,
      })
      .then(() => {
        store.dispatch("eoi/getEoiCounter", store.state.user.selectedEstateId);
        emits("confirm");
      })
      .catch((error) => {
        if (error.response.status === 409) {
          emits("confirm");
          toast.error("The action has already been performed.");
        } else {
          toast.error("Something went wrong");
        }
      });
  };

const __returned__ = { toast, emits, props, close, confirm, LotAssignmentModal, get store() { return store }, get useToast() { return useToast } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})